/*
 * @Author: songyuhang songyuhang@myhexin.com
 * @Date: 2023-07-04 10:39:00
 * @LastEditors: zhaozhenda
 * @LastEditTime: 2024-08-26 09:35:56
 */
import { Request } from './request';
import { getCurrentEnvMode } from '@/utils/tools';

const env = getCurrentEnvMode();

// baseUrl
const baseURL = {
  dev: '/api',
  test: '//khtest.10jqka.com.cn/mncgdocker/moni/simulation-gateway/application',
  release: '//moni.10jqka.com.cn/simulation-gateway/application',
};
// 动态运营配置baseUrl
const dynamicBaseURL = {
  dev: '//testm.10jqka.com.cn/eq/open/api/dynamic_configuration/v1/config_list',
  test: '//testm.10jqka.com.cn/eq/open/api/dynamic_configuration/v1/config_list',
  release: '//eq.10jqka.com.cn/eq/open/api/dynamic_configuration/v1/config_list',
};

// 榫卯平台url
const tenonURL = {
  dev: '/sunmao',
  test: '//testm.10jqka.com.cn/operation/material/sunmao',
  release: '//mams.10jqka.com.cn',
};

const tjUrl = {
  dev: '/tj',
  test: '//khtest.10jqka.com.cn/tenon_genius/assembly/',
  release: '//mams.10jqka.com.cn/assembly/',
};

const baseURLCommon = {
  dev: '//khtest.10jqka.com.cn/mncgdocker/moni/simulation-gateway/common',
  test: '//khtest.10jqka.com.cn/mncgdocker/moni/simulation-gateway/common',
  release: '//moni.10jqka.com.cn/simulation-gateway/common',
};

const requestCommon = new Request({ baseURL: baseURLCommon[env] });
const request = new Request({ baseURL: baseURL[env] });
const requestX = new Request({
  baseURL: baseURL[env],
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  withCredentials: true,
});
const requestTj = new Request({ baseURL: tjUrl[env] });
const requestDynamic = new Request({ baseURL: dynamicBaseURL[env] });
const requestTenon = new Request({ baseURL: tenonURL[env] });
export { request, requestX, requestDynamic, requestTenon, requestCommon, requestTj };
